import getSnippetInstance from '../zend-desk/get-snippet-instance';

const showContactForm = async (options = { onHide: Function.prototype }) => {
  const widget = await getSnippetInstance(options);
  widget.showContactForm();
};

export default showContactForm;
